import React from 'react';
import './Keycap.scss';
import { Text } from '../text/Text.tsx';

type KeycapTheme = 'normal' | 'fun' | 'green';

type KeycapProps = {
  content: string;
  theme?: KeycapTheme;
  onClick?: () => void;
};

const Keycap: React.FC<KeycapProps> = ({ content, theme = 'normal', onClick }) => {
  return (
    <div className={`kk-bg ${theme}`}>
      <div className="kk-bottom-frame">
        <div className="kk-inner-frame" onClick={onClick}>
          <Text variant="body">{content}</Text>
        </div>
      </div>
    </div>
  );
};

export default Keycap;
